import { render, staticRenderFns } from "./LeaderShow.vue?vue&type=template&id=2f37c28f&scoped=true&"
import script from "./LeaderShow.vue?vue&type=script&lang=js&"
export * from "./LeaderShow.vue?vue&type=script&lang=js&"
import style0 from "./LeaderShow.vue?vue&type=style&index=0&id=2f37c28f&lang=scss&scoped=true&"
import style1 from "./LeaderShow.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37c28f",
  null
  
)

export default component.exports